import {Component, Input} from '@angular/core';
import {FormControl,ReactiveFormsModule} from "@angular/forms";
import {NgClass, NgOptimizedImage} from "@angular/common";
import {SubtitlesService} from "../../../core";

@Component({
    selector: 'form-email-input',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        NgClass,
        NgOptimizedImage,
    ],
    templateUrl: './form-email-input.component.html',
    styleUrl: './form-email-input.component.scss'
})
export class FormEmailInputComponent {
    @Input({required: true}) emailControl!: FormControl;

    constructor(public subtitles: SubtitlesService) {
    }

    isInvalid(): boolean {
        return this.emailControl?.invalid && (this.emailControl?.dirty || this.emailControl?.touched);
    }
}
